import { createContext, useCallback, useContext } from 'react';
import { useFormContext } from 'react-hook-form';

const VenueOpeningHoursEditModeContext = createContext();

export const VenueOpeningHoursEditProvider = ({ fieldName, children }) => {
  const value = useVenueOpeningHoursEditProvider({ fieldName });
  return (
    <VenueOpeningHoursEditModeContext.Provider value={value}>
      {children}
    </VenueOpeningHoursEditModeContext.Provider>
  );
};

const useVenueOpeningHoursEditProvider = ({ fieldName }) => {
  const { getValues } = useFormContext();
  const value = getValues(fieldName);

  const getIsDayUsed = useCallback(
    (dayIndex) => {
      return value.reduce((current, { schedule_days }) => {
        return current || schedule_days[dayIndex].selected;
      }, false);
    },
    [value]
  );

  return {
    value,
    getIsDayUsed,
  };
};

export const useVenueOpeningHoursEdit = () => useContext(VenueOpeningHoursEditModeContext);
